import { useCallback, useEffect, useState } from 'react';

import { DomainObject } from 'types';

import { fetchDetail } from '../grid-api';

export function useFetchDetail<TObject extends DomainObject = DomainObject>(
  url: string,
  id?: string,
  disabledLoad?: boolean
) {
  const [item, setItem] = useState<TObject | undefined>(undefined);

  const getData = useCallback(async () => {
    try {
      const response = await fetchDetail<TObject>(url);

      setItem(response);
    } catch (e) {
      console.log(e);

      setItem(undefined);
    }
  }, [url]);

  useEffect(() => {
    if (id && !disabledLoad) {
      getData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, url]);

  return { item, refreshDetail: getData };
}
